module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgment")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Thanks to Alamelu and Anumarla Govindan, PhD for sharing their first-hand knowledge of South India and its customs. And Stephen Biesty and Richard Platt for the information on ships and sailing in their book, "), _c('em', [_vm._v("‘The Coolest Cross-Sections Ever’.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Also, Miles F. Potter’s, "), _c('em', [_vm._v("‘Oregon’s Golden Years’")]), _vm._v(" for information on the gold rush in Baker County, Oregon.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The cover illustration: "), _c('em', [_vm._v("‘Unicorn in a Misty Forest Glade’")]), _vm._v(" was prepared by C. Atkinson. It is available at www.shutterpoint.com.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Typography and maps were prepared by the author.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0